//import { CoverPage } from './../cover/cover';
import { Component } from '@angular/core';
import { IonicPage, NavController, NavParams, ViewController } from 'ionic-angular';
import { StoryProvider } from '../../providers/story/story';
//import * as firebase from 'firebase';
import 'firebase/firestore';
//import moment from 'moment';

@IonicPage()
@Component({
  selector: 'page-chapters',
  templateUrl: 'chapters.html',
})
export class ChaptersPage {
 
  public chapters: any;
  public storie: any;
  //private db: any;
  private chaptersIDs: any;
  public date: any;
  public dateChapter; any;
  public newChap: boolean;
  stories: any;
  public reversed: any;
  public capi: any;

  public capitulos: any;

  constructor(public navCtrl: NavController,
    public navParams: NavParams,
    public viewCtrl: ViewController,
    public storyProvider: StoryProvider) {
    let ion = this;

    let data = navParams.get('data');
    //ion.db = firebase.firestore();

    ion.chaptersIDs = data.chapters;
    //console.log("INFORMACION DE LOS CAPITULOS DESDE COVER", ion.chaptersIDs);
    //console.log("INFORMACION DE LOS CAPITULOS DESDE COVER", data);

    // this.capitulos = ion.chaptersIDs;
    // for (let numero in this.capitulos) {
    //   this.capi = numero
    //   console.log(this.capi);
    // }
  }

  ionViewDidLoad() {
    this.getChapters();
  }

  getChapters() {
    let ion = this;
    let dateNow = new Date().getTime() / 1000;

    ion.storyProvider.getChapters(ion.chaptersIDs).then(Chapters => {

      //ion.chapters = Chapters;
      Chapters.forEach(chapter => {
        if (chapter.date.seconds > (dateNow - 864000)) {
          //console.log("El CAPITULO ES NUEVOOOOO TIENE MENOS DE 10 DIAS", chapter.title);
          chapter.newChap = true;
        } else {
          //console.log("El CAPITULO ES VIEJOOOOO TIENE MAS DE 10 DIAS");
          chapter.newChap = false;
        }
      });

     // console.log("HISTORIAS VINCULADAS", Chapters);

      var cap = Chapters.length
//      console.log("LONGITUD DEL ARREGLO", cap + 1);
      //console.log("LONGITUD DEL ARREGLO", cap);
      ion.chapters = Chapters;
      this.reversed = ion.chapters.reverse();
      //console.log('reversed: ', this.reversed);
    });
  }

  goCover(storie) {
    let data;   
    data = {
      storie: storie,
      chaptersIDs: this.chaptersIDs
    }
    //console.log("DATA DISMISSS", data)
    //console.log("chaptersIDs", this.chaptersIDs)
    this.viewCtrl.dismiss(data);
  }

  closeModal(updateStorie) {
    this.viewCtrl.dismiss(updateStorie);
  }

}


// WEBPACK FOOTER //
// ./src/pages/chapters/chapters.ts